/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { ICollectionSortOption } from 'volta/models/types/collection-view';

import Component from '@glimmer/component';

export interface CollectionViewSortListSignature {
  Args: {
    options: ICollectionSortOption[];
    sortLimit?: number;
    disabled?: boolean;
    onDirectionChange?: (sort: ICollectionSortOption) => void;
    onSelectionChange?: (sort: ICollectionSortOption, checked: boolean) => void;
    onReorderOptions?: (sortOptions: ICollectionSortOption[]) => void;
  };
}

export default class CollectionViewSortListComponent extends Component<CollectionViewSortListSignature> {
  resourceName = { singular: 'sort', plural: 'sorts' };

  handleSortEndAction = ([sortOptions]: ICollectionSortOption[][]) => {
    this.args.onReorderOptions?.([...(sortOptions ?? [])]);
  };
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CollectionView::SortList': typeof CollectionViewSortListComponent;
    'collection-view/sort-list': typeof CollectionViewSortListComponent;
  }
}
